export default "__VITE_ASSET__DdY5loHj__"